import React, { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Box,
  Container,
  Paper,
  IconButton,
} from "@mui/material";
import {
  Facebook,
  Instagram,
  Campaign,
  Storefront,
  TrendingUp,
  EmojiEvents,
  ArrowForward,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import MethodGet from "../../config/Service";
import FormatCurrency from "../../utils/FormatCurrency";

const distributors = [
  {
    name: "MerryColor Guadalajara",
    address: "Calle José María Morelos, #673, Zona Centro",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3732.8336994842443!2d-103.35556872399202!3d20.676343680886223!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8428b15416183c95%3A0x12ce378ca1ecd83d!2sMerryColor%20Guadalajara!5e0!3m2!1ses-419!2smx!4v1738430805075!5m2!1ses-419!2smx",
    social: {
      facebook: "#",
      instagram: "#",
    },
  },
  {
    name: "MerryColor Mazatlán",
    address: "Gran Plaza Mazatlán",
    map: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6149.354450293875!2d-106.44232786990307!3d23.23937265503015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x869f536092ea14df%3A0x3834aadffd718487!2sGran%20Plaza%20Mazatl%C3%A1n!5e0!3m2!1ses-419!2smx!4v1738432101230!5m2!1ses-419!2smx",
    social: {
      facebook: "https://www.facebook.com/profile.php?id=61568240134654",
      instagram: "#",
    },
  },
];

const steps = [
  {
    step: "01",
    title: "Inscríbete",
    icon: <Campaign sx={{ fontSize: 40 }} />,
    description:
      "Adquiere un rol de afiliado, el cual te dará acceso a múltiples beneficios con la marca.",
  },
  {
    step: "02",
    title: "Súrtete",
    icon: <Storefront sx={{ fontSize: 40 }} />,
    description:
      "Realiza tus compras con un porcentaje de descuento exclusivo solo para afiliados.",
  },
  {
    step: "03",
    title: "Vende y Gana",
    icon: <TrendingUp sx={{ fontSize: 40 }} />,
    description:
      "Vende productos con tus clientes, familiares y conocidos y genera ingresos.",
  },
];

const Distributors = () => {
  const [discounts, setDiscounts] = useState([]);

  useEffect(() => {
    MethodGet("/distribucion/discountsNoAuth")
      .then((res) => {
        setDiscounts(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <Box sx={{ background: "#fff" }}>
      {/* Hero Section */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #801F56 0%, #9A457F 50%, #FAA5B7 100%)",
          py: { xs: 10, md: 14 },
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative circles */}
        <Box
          sx={{
            position: "absolute",
            top: "-50px",
            right: "-50px",
            width: 200,
            height: 200,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.1)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: "-30px",
            left: "10%",
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "rgba(255,255,255,0.08)",
          }}
        />

        <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
          <Typography
            sx={{
              color: "#FAA5B7",
              fontWeight: 700,
              fontSize: "0.9rem",
              letterSpacing: "2px",
              textTransform: "uppercase",
              textAlign: "center",
              mb: 2,
            }}
          >
            🚀 Programa de Afiliados
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "2.2rem", md: "3.2rem" },
              fontWeight: 800,
              color: "#fff",
              textAlign: "center",
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Conviértete en Afiliado MerryColor
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: "1rem", md: "1.2rem" },
              color: "#fff",
              opacity: 0.9,
              textAlign: "center",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            Accede a grandes descuentos, promociones exclusivas y comienza a
            generar ingresos vendiendo productos de belleza de alta calidad.
          </Typography>

          {/* CTA Button */}
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <Box
              component={Link}
              to="/registro"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1,
                background: "#fff",
                color: "#801F56",
                px: 4,
                py: 1.5,
                borderRadius: "50px",
                fontWeight: 700,
                fontSize: "1rem",
                textDecoration: "none",
                transition: "all 0.2s",
                "&:hover": {
                  transform: "scale(1.05)",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
                },
              }}
            >
              Únete ahora
              <ArrowForward sx={{ fontSize: 20 }} />
            </Box>
          </Box>
        </Container>
      </Box>

      {/* How it Works */}
      <Box sx={{ py: 10, background: "#FFF5F8" }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: { xs: "1.8rem", md: "2.2rem" },
              fontWeight: 800,
              textAlign: "center",
              color: "#333",
              mb: 6,
            }}
          >
            ¿Cómo funciona? ✨
          </Typography>

          <Grid container spacing={4}>
            {steps.map((item, index) => (
              <Grid item xs={12} md={4} key={index}>
                <Paper
                  elevation={0}
                  sx={{
                    p: 4,
                    borderRadius: "20px",
                    textAlign: "center",
                    height: "100%",
                    background: "#fff",
                    border: "1px solid #f0f0f0",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 15px 50px rgba(128, 31, 86, 0.1)",
                    },
                  }}
                >
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      borderRadius: "20px",
                      background: "linear-gradient(135deg, #FAA5B7 0%, #F0C9D5 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 20px",
                      color: "#801F56",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "2.5rem",
                      fontWeight: 800,
                      background: "linear-gradient(135deg, #801F56, #FAA5B7)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                      mb: 1,
                    }}
                  >
                    {item.step}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "1.2rem",
                      color: "#333",
                      mb: 1,
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography sx={{ color: "#666", lineHeight: 1.7 }}>
                    {item.description}
                  </Typography>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* Discount Levels */}
      {discounts.length > 0 && (
        <Box sx={{ py: 10, background: "#fff" }}>
          <Container maxWidth="lg">
            <Typography
              sx={{
                fontSize: { xs: "1.8rem", md: "2.2rem" },
                fontWeight: 800,
                textAlign: "center",
                color: "#333",
                mb: 2,
              }}
            >
              Niveles de Descuento 💰
            </Typography>
            <Typography
              sx={{
                color: "#666",
                textAlign: "center",
                mb: 6,
                maxWidth: "500px",
                margin: "0 auto 48px",
              }}
            >
              Mientras más compres, más ahorras. Alcanza niveles más altos para
              obtener mayores beneficios.
            </Typography>

            <Grid container spacing={3} justifyContent="center">
              {discounts.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Paper
                    elevation={0}
                    sx={{
                      p: 4,
                      borderRadius: "20px",
                      textAlign: "center",
                      background: index === discounts.length - 1
                        ? "linear-gradient(135deg, #801F56, #9A457F)"
                        : "#FFF5F8",
                      color: index === discounts.length - 1 ? "#fff" : "#333",
                      border: index === discounts.length - 1 ? "none" : "2px solid #FAA5B7",
                      transition: "all 0.3s",
                      "&:hover": {
                        transform: "scale(1.02)",
                      },
                    }}
                  >
                    {index === discounts.length - 1 && (
                      <EmojiEvents
                        sx={{ fontSize: 40, color: "#FFD700", mb: 1 }}
                      />
                    )}
                    <Typography
                      sx={{
                        fontSize: "3rem",
                        fontWeight: 800,
                        lineHeight: 1,
                      }}
                    >
                      {item.discount}%
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        opacity: 0.9,
                      }}
                    >
                      de descuento
                    </Typography>
                    <Box
                      sx={{
                        pt: 2,
                        borderTop: `1px solid ${index === discounts.length - 1 ? "rgba(255,255,255,0.2)" : "#FAA5B7"}`,
                      }}
                    >
                      <Typography sx={{ fontSize: "0.9rem", opacity: 0.8 }}>
                        Compra mínima:{" "}
                        <strong>{FormatCurrency(Number(item.money_discount_min))} MXN</strong>
                      </Typography>
                      <Typography sx={{ fontSize: "0.9rem", opacity: 0.8 }}>
                        Compra máxima:{" "}
                        <strong>{FormatCurrency(Number(item.money_discount_max))} MXN</strong>
                      </Typography>
                    </Box>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      )}

      {/* Distributors */}
      <Box sx={{ py: 10, background: "#FBFAFF" }}>
        <Container maxWidth="lg">
          <Typography
            sx={{
              fontSize: { xs: "1.8rem", md: "2.2rem" },
              fontWeight: 800,
              textAlign: "center",
              color: "#333",
              mb: 2,
            }}
          >
            Nuestros Distribuidores 📍
          </Typography>
          <Typography
            sx={{
              color: "#666",
              textAlign: "center",
              mb: 6,
              maxWidth: "500px",
              margin: "0 auto 48px",
            }}
          >
            Visita alguna de nuestras sucursales autorizadas y descubre nuestros
            productos en persona.
          </Typography>

          <Grid container spacing={4}>
            {distributors.map((dist, idx) => (
              <Grid item xs={12} md={6} key={idx}>
                <Paper
                  elevation={0}
                  sx={{
                    borderRadius: "20px",
                    overflow: "hidden",
                    background: "#fff",
                    border: "1px solid #f0f0f0",
                    transition: "all 0.3s",
                    "&:hover": {
                      boxShadow: "0 15px 50px rgba(128, 31, 86, 0.1)",
                    },
                  }}
                >
                  {/* Map */}
                  <Box sx={{ height: 250, position: "relative" }}>
                    <iframe
                      src={dist.map}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      title={dist.name}
                    />
                  </Box>

                  {/* Info */}
                  <Box sx={{ p: 3 }}>
                    <Typography
                      sx={{ fontWeight: 700, fontSize: "1.2rem", color: "#333", mb: 0.5 }}
                    >
                      {dist.name}
                    </Typography>
                    <Typography sx={{ color: "#666", fontSize: "0.9rem", mb: 2 }}>
                      {dist.address}
                    </Typography>

                    {/* Social */}
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <IconButton
                        component="a"
                        href={dist.social.facebook}
                        target="_blank"
                        sx={{
                          background: "#FFF5F8",
                          color: "#801F56",
                          "&:hover": { background: "#FAA5B7", color: "#fff" },
                        }}
                      >
                        <Facebook />
                      </IconButton>
                      <IconButton
                        component="a"
                        href={dist.social.instagram}
                        target="_blank"
                        sx={{
                          background: "#FFF5F8",
                          color: "#801F56",
                          "&:hover": { background: "#FAA5B7", color: "#fff" },
                        }}
                      >
                        <Instagram />
                      </IconButton>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>

      {/* CTA Section */}
      <Box
        sx={{
          py: 8,
          background: "linear-gradient(135deg, #801F56, #9A457F)",
          textAlign: "center",
        }}
      >
        <Container maxWidth="sm">
          <Typography
            sx={{
              fontSize: { xs: "1.6rem", md: "2rem" },
              fontWeight: 700,
              color: "#fff",
              mb: 2,
            }}
          >
            ¿Listo para empezar?
          </Typography>
          <Typography sx={{ color: "#FAA5B7", mb: 3 }}>
            Únete a nuestra red de afiliados y comienza a generar ingresos hoy
            mismo.
          </Typography>
          <Box
            component={Link}
            to="/registro"
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 1,
              background: "#fff",
              color: "#801F56",
              px: 4,
              py: 1.5,
              borderRadius: "50px",
              fontWeight: 700,
              textDecoration: "none",
              transition: "all 0.2s",
              "&:hover": {
                transform: "scale(1.05)",
                boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              },
            }}
          >
            Registrarse ahora
            <ArrowForward sx={{ fontSize: 20 }} />
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Distributors;
